import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/knowledge-base/redux/actions';

export class DefaultPage extends Component {
  static propTypes = {
    knowledgeBase: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    searchString: '',
  };

  getResultsForSearchString = ({ target: { value } }) => {
    console.log(value);
    this.setState({ searchString: value });
  };

  render() {
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <div className="knowledge-base-default-page">
              <input name="searchString" onChange={this.getResultsForSearchString} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    knowledgeBase: state.knowledgeBase,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
